import { Hero } from '@/components/sections/hero';
import { Features } from '@/components/sections/features';
import { Conversion } from '@/components/sections/conversion';
import { PreviewSection } from '@/components/preview/preview-section';
import { BottomCTA } from '@/components/sections/bottom-cta';

export function Home() {
  return (
    <main>
      <Hero />
      <Features />
      <Conversion />
      <PreviewSection />
      <BottomCTA />
    </main>
  );
}